import connector from 'Utils/connector';
import {
  getSitemapIndex,
  selectLoading,
  selectSitemapIndex,
} from 'Webapp/shared/concepts/sitemap';
import Sitemap from 'Webapp/shared/app/views/sitemap-index';

export default connector({
  actions: {
    getSitemapIndex,
  },
  selectors: {
    loading: selectLoading,
    index: selectSitemapIndex,
  },
})(Sitemap);
